module.exports = "/images/menu-home.svg?411ba317bd275ef751db78302ffe7df6";